import React from 'react';
import { InfoCard } from 'types/launcher';

interface InfoCardContext {
  infocard?: InfoCard;
}

export const InfoCardContext = React.createContext<InfoCardContext>({} as InfoCardContext);
